module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GW-f1a68a52ffbc537c90d3dc3a0a8098d9.png";